import { CookiesName } from '@/api';
import { useCookies } from 'vue3-cookies';
import { TLoginApiResponse } from '@/types/users/index';
const { cookies } = useCookies();

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(v) || 'Please enter a valid email address';
  },
  password: (v: string) => {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]{8,64}$/;
    return pattern.test(v) || 'Пароль должен содержать минимум 8 символов, хотя бы одну заглавную букву, одну строчную букву, одну цифру и один специальный символ.';
  },
  arrayHasItems: (v: any) => !!v && Array.isArray(v) && v?.length > 0 || 'This field is required',
  required: (v: any) => !!v || 'This field is required',
  minLength: (v: any, length: number) => v?.length >= length || `Минимальная длина поля ${length} символов`,
  maxLength: (v: any, length: number) => (v?.length ?? 0) <= length || `Максимальная длина поля ${length} символов`,
};

export const setAllCookies = (response: TLoginApiResponse) => {
  cookies.set(CookiesName.token, response.accessToken);
  cookies.set(CookiesName.refreshToken, response.refreshToken);
};

export const removeAllCookies = () => {
  cookies.remove(CookiesName.token);
  cookies.remove(CookiesName.refreshToken);
};

export const tokenIsValid = () => {
  const token = cookies.get(CookiesName.token);
  return !!token;
};

export const refreshTokenIsValid = () => {
  const token = cookies.get(CookiesName.refreshToken);
  return !!token;
};

